import { api } from '@/api';
import router from '@/router';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetStaffDashboardStatisticsByStaff,
    commitSetStaffDashboardStatistics, commitSetStaffDashboardStatisticsByCountries, commitSetUsersImportsList,
} from './mutations';
import { StaffState } from './state';
import { dispatchCheckApiError } from '../main/actions';

type MainContext = ActionContext<StaffState, State>;

export const actions = {
    async actionGetStaffDashboardStatistics(context: MainContext, payload: {period?: string, view_user_id?: number}) {
        try {
            const response = await api.getStaffDashboardStatistics(context.rootState.main.token, payload);
            if (response.data) {
                commitSetStaffDashboardStatistics(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetStaffDashboardStatisticsByCountries(context: MainContext, payload: {period?: string}) {
        try {
            const response = await api.getStaffDashboardStatisticsByCountries(context.rootState.main.token, payload);
            if (response.data) {
                commitSetStaffDashboardStatisticsByCountries(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetStaffDashbordStatisticsByStaff(
        context: MainContext, payload: {period?: string, search?: string, group?: null | number},
    ) {
        try {
            const response = await api.getStaffDashboardStatisticsByStaff(context.rootState.main.token, payload);
            if (response.data) {
                commitSetStaffDashboardStatisticsByStaff(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetUsersImportsList(context: MainContext) {
        try {
            const response = await api.getUsersImportsList(context.rootState.main.token);
            if (response.data) {
                commitSetUsersImportsList(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionSaveUsersImport(context: MainContext, payload: FormData) {
        try {
            const response = await api.saveUsersImport(context.rootState.main.token, payload);
            await dispatchGetUsersImportsList(context);
            return true;
        } catch (error) {
            await dispatchCheckApiError(context, error);
            return false;
        }
    },
    async actionStartUsersImport(context: MainContext, payload: {import_id: number, create_users: boolean}) {
        try {
            const response = await api.startUsersImport(context.rootState.main.token, payload);
            await dispatchGetUsersImportsList(context);
            return true;
        } catch (error) {
            await dispatchCheckApiError(context, error);
            return false;
        }
    },
    async actionSubmitRemoveUser(context: MainContext, payload: {user_id: number}) {
        try {
            const response = await api.submitRemoveUser(context.rootState.main.token, payload);
            return true;
        } catch (error) {
            await dispatchCheckApiError(context, error);
            return false;
        }
    },
};

const { dispatch } = getStoreAccessors<StaffState | any, State>('');

export const dispatchGetStaffDashboardStatistics = dispatch(actions.actionGetStaffDashboardStatistics);
export const dispatchGetStaffDashboardStatisticsByCountries = dispatch(
    actions.actionGetStaffDashboardStatisticsByCountries,
);
export const dispatchGetStaffDashboardStatisticsByStaff = dispatch(
    actions.actionGetStaffDashbordStatisticsByStaff,
);
export const dispatchGetUsersImportsList = dispatch(actions.actionGetUsersImportsList);
export const dispatchSaveUsersImport = dispatch(actions.actionSaveUsersImport);
export const dispatchStartUsersImport = dispatch(actions.actionStartUsersImport);
export const dispatchSubmitRemoveUser = dispatch(actions.actionSubmitRemoveUser);
